import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
    DNA,
    TailSpin,
    Bars,
    Puff,
    Circles,
    ThreeDots,
} from "react-loader-spinner";

const Loader = ({
    height,
    width,
    color,
    type,
    ariaLabel,
    className,
    duration = 3000, // Default duration is set to 3 seconds
}) => {
    const loading = useSelector((state) => state.loader.loading);
    const [visible, setVisible] = useState(loading);

    useEffect(() => {
        if (loading) {
            setVisible(true);
            const timer = setTimeout(() => {
                setVisible(false);
            }, duration); // Set the loader to disappear after the duration

            return () => clearTimeout(timer); // Cleanup timeout on unmount
        } else {
            setVisible(false); // If loading becomes false, hide loader immediately
        }
    }, [loading, duration]);

    const spinnerTypes = {
        dna: (
            <DNA
                height={height}
                width={width}
                color={color}
                ariaLabel={ariaLabel}
                wrapperStyle={{}}
                wrapperClass="dna-wrapper"
            />
        ),
        tailspin: <TailSpin height={height} width={width} color={color} />,
        bars: <Bars height={height} width={width} color={color} />,
        puff: <Puff height={height} width={width} color={color} />,
        threedots: <ThreeDots height={height} width={width} color={color} />,
        circles: <Circles height={height} width={width} color={color} />,
    };

    if (!visible) return null;

    return <div className={className}>{spinnerTypes[type]}</div>;
};

export default Loader;
